// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"Clients_pageLayout__1lFQa","intro":"Clients_intro__2kqw_","introtxt":"Clients_introtxt__3D4iR"};